import { servicesWithVisa } from 'common/data/services';

export const isVisaServiceType = visa => servicesWithVisa.includes(visa);
